import isFunction from './is-function';

/**
 * use setTimeout to force a function to run asynchoronously
 * @param {Function} callback callback function to run async
 */
export default function(callback) {
    if(isFunction(callback)) {
        setTimeout(callback, 0);
    }
};
